import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "@bamboobox/b2logincheck";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          fontFamily: "'Inter', sans-serif",
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document
  
  .getElementById('root'));
root.render(
  <React.StrictMode>
  <AuthProvider loginURL={window._env_.LOGIN_URL} authcheckURL={window._env_.AUTH_URL}>
    <ThemeProvider theme={theme}>
      <Router>
      <App />
      </Router>
    </ThemeProvider>
  </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
